module.exports = __webpack_public_path__ + "static/media/66800008-N7T0wSgs.ae2e5731.JPG";